<template>
  <v-container>
    <v-btn color="primary" class="mb-4" @click="exportToPDF">
      Export to PDF
    </v-btn>

    <!-- Wrapper div for PDF -->
    <div ref="pdfContent">
      <v-expansion-panels v-model="expandedPanels" multiple>
        <v-expansion-panel v-for="(form, index) in forms" :key="index">
          <v-expansion-panel-header>
            {{ form.title }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-html="form.content" class="mb-3" />
            <div v-if="form.signature" class="mt-2">
              <strong>Signature:</strong>
              <div v-if="form.signature.type === 'typed'">
                {{ form.signature.value }}
              </div>
              <div v-else-if="form.signature.type === 'image'">
                <img
                  :src="form.signature.value"
                  alt="Signature"
                  style="max-width: 300px"
                />
              </div>
              <div v-else-if="form.signature.type === 'hash'">
                <v-chip color="grey lighten-2" small>
                  {{ form.signature.value }}
                </v-chip>
                <div>
                  <small
                    >Hash Algorithm: {{ form.signature.hash_algorithm }}</small
                  >
                </div>
              </div>
            </div>
            <v-row dense>
              <v-col cols="12" sm="6">
                <strong>Signed At:</strong> {{ form.signedAt }}
              </v-col>
              <!-- <v-col cols="12" sm="6">
                <strong>Signed By IP:</strong> {{ form.signedByIp }}
              </v-col> -->
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-container>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "FormsSignedViewer",
  props: {
    value: {
      type: [Array, String],
      required: true,
    },
  },
  data() {
    return {
      expandedPanels: [],
    };
  },
  computed: {
    forms() {
      try {
        let parsed = this.value;
        while (typeof parsed === "string") parsed = JSON.parse(parsed);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.error("Invalid signed form JSON:", e);
        return [];
      }
    },
  },
  // watch: {
  //   forms: {
  //     immediate: true,
  //     handler(newVal) {
  //       // Automatically expand all panels for PDF export
  //       this.expandedPanels = newVal.map((_, i) => i);
  //     },
  //   },
  // },
  methods: {
    formatDate(dateStr) {
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateStr).toLocaleDateString(undefined, options);
    },
    exportToPDF() {
      const element = this.$refs.pdfContent;

      html2pdf()
        .set({
          margin: 0.5,
          filename: "signed_forms.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        })
        .from(element)
        .save()
        .catch((error) => {
          console.error("PDF export failed:", error);
        });
    },
  },
};
</script>

<style scoped>
img {
  border: 1px solid #ccc;
  padding: 4px;
  border-radius: 4px;
}
</style>
